/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as Sentry from '@sentry/nextjs';
import { SENTRY_DENY_URLS, SENTRY_IGNORE_ERRORS } from './src/common/Sentry';
import { env } from './src/common/util/env';

const { SENTRY_DSN, REPO_HASH } = env;

const NODE_ENV = process.env.NODE_ENV;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: NODE_ENV,
  // Sample 1% of production user's performance
  tracesSampleRate: 0.01,
  beforeSend: event => {
    event.tags = event.tags || {};
    event.tags['release'] = `unicron@${REPO_HASH}`;
    return event;
  },
  ignoreErrors: SENTRY_IGNORE_ERRORS,
  denyUrls: SENTRY_DENY_URLS,
  enabled: NODE_ENV === 'production',
});
